import { render, staticRenderFns } from "./MismatchInfoModal.vue?vue&type=template&id=b6e68130&scoped=true&"
import script from "./MismatchInfoModal.vue?vue&type=script&lang=js&"
export * from "./MismatchInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./MismatchInfoModal.vue?vue&type=style&index=0&id=b6e68130&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6e68130",
  null
  
)

export default component.exports